module.exports = __webpack_public_path__ + "img/IMG_8509.22869bf7.jpg";